export default __webpack_public_path__ + "static/media/2. blur .22b25538.jpg";